<template>
	<div data-tour-scope="insights">
		<v-main>
			<v-container fluid class="in-page">
				<div class="in-top">
					<!-- solo se aperta da un'altra pagina (es. consigli della scheda prodotto) -->
					<v-btn v-if="ret" icon :title="ret.label" @click="back"><v-icon>mdi-arrow-left</v-icon></v-btn>
					<div>
						<div class="in-title">Consigli</div>
						<div class="in-muted">
							Ogni notte i dati del negozio vengono analizzati per proporti cosa fare: con il valore stimato, il perché e l'azione a un clic.
							<span v-if="getSummary && getSummary.generatedAt">Ultimo aggiornamento {{ getSummary.generatedAt | moment('DD/MM/YYYY HH:mm') }}.</span>
						</div>
					</div>
					<v-spacer></v-spacer>
					<v-btn outlined color="primary" @click="apri({ tipo: 'simulator' })"><v-icon left>mdi-calculator-variant-outline</v-icon>Simulatore “e se”</v-btn>
					<v-btn text color="primary" :loading="ricalcolo" @click="aggiorna"><v-icon left>mdi-refresh</v-icon>Aggiorna ora</v-btn>
				</div>

				<v-tabs v-model="tabTipo" class="in-tabs mb-3" background-color="transparent">
					<v-tab v-for="t in TIPI" :key="t.value"
						><v-icon small left>{{ t.icona }}</v-icon
						>{{ t.label }}</v-tab
					>
				</v-tabs>

				<InsightsKpi :summary="getSummary" :selected="settings.filters.area" @select="settings.filters.area = $event" />

				<SectionCard v-if="tipo === 'radar'" :title="tipoCorrente.label" :icon="tipoCorrente.icona" :subtitle="radarItems.length === 1 ? '1 consiglio' : radarItems.length + ' consigli'" class="mt-4">
					<InsightsRadar :items="radarItems" @open="apri" @status="cambiaStato" />
				</SectionCard>

				<SectionCard v-else :title="tipoCorrente.label" :icon="tipoCorrente.icona" :subtitle="total === 1 ? '1 consiglio' : total + ' consigli'" class="mt-4">
					<div v-if="tipo === 'viewed'" class="in-muted mb-3">
						Prodotti con molte visite sul sito negli ultimi 30 giorni che convertono meno della metà della loro categoria. Lo sconto proposto resta dentro il margine minimo del 15% e, se
						c'è, si avvicina al prezzo del concorrente; il coupon è pensato per chi il prodotto l'ha già guardato.
					</div>
					<div class="in-filters">
						<v-text-field
							v-model="searchfield"
							label="Cerca nei consigli"
							outlined
							dense
							hide-details
							prepend-inner-icon="mdi-magnify"
							clearable
							class="in-search"
							@keyup.enter="getSearch()"
							@click:clear="pulisciRicerca"
						/>
						<div class="in-states">
							<v-chip
								v-for="(s, codice) in STATI"
								:key="codice"
								small
								:outlined="statoFiltro !== codice"
								:color="statoFiltro === codice ? s.colore : undefined"
								:text-color="statoFiltro === codice ? 'white' : undefined"
								@click="settings.filters.status = codice"
							>
								<v-icon x-small left>{{ s.icona }}</v-icon
								>{{ s.label }}
							</v-chip>
						</div>
					</div>

					<div v-if="!getItems.length" class="in-empty">
						<v-icon large color="grey lighten-1">mdi-lightbulb-off-outline</v-icon>
						<div>Nessun consiglio{{ filtriAttivi ? ' con questi filtri' : '' }}.</div>
						<div class="in-muted">I consigli si aggiornano ogni notte; con "Aggiorna ora" puoi ricalcolarli subito.</div>
					</div>

					<v-data-table
						v-else
						:headers="headers"
						:items="getItems"
						:options.sync="settings.options"
						:server-items-length="total"
						must-sort
						class="elevation-0"
						:footer-props="{ 'items-per-page-options': listSize }"
						item-key="_id"
						:hide-default-header="mobileCards"
						:class="{ 'table-cards': mobileCards }"
					>
						<template v-slot:body="{ items }">
							<!-- telefono: ogni consiglio diventa una card -->
							<tbody v-if="mobileCards" class="in-cards">
								<tr v-for="item in items" :key="item._id">
									<td :colspan="headers.length" class="px-0 py-1">
										<key-value-card :fields="campiCard(item)" :image="item.data.image || ''">
											<template #title>
												<span class="in-name">{{ item.title }}</span>
											</template>
											<template #actions>
												<InsightRowMenu :item="item" @open="apri" @status="cambiaStato" />
											</template>
										</key-value-card>
									</td>
								</tr>
							</tbody>
							<tbody v-else-if="tipo === 'viewed'">
								<tr v-for="item in items" :key="item._id">
									<td class="pl-1 pr-0" style="width: 44px"><InsightRowMenu :item="item" @open="apri" @status="cambiaStato" /></td>
									<td style="width: 64px">
										<div class="in-thumb">
											<img v-if="item.data.image" :src="item.data.image" alt="" loading="lazy" />
											<v-icon v-else small color="grey lighten-1">mdi-image-off-outline</v-icon>
										</div>
									</td>
									<td class="text-left">
										<div class="font-weight-medium in-name">{{ item.data.title || '—' }}</div>
										<div class="in-muted">{{ item.data.sku }}</div>
									</td>
									<td class="text-right">{{ item.data.views }}</td>
									<td class="text-right">{{ item.data.orders }}</td>
									<td class="text-right text-no-wrap">
										<div class="error--text font-weight-medium">{{ percento(item.data.conv) }}</div>
										<div class="in-muted">categoria {{ percento(item.data.catConv) }}</div>
									</td>
									<td class="text-right text-no-wrap">{{ euroCent(item.data.price) }}</td>
									<td class="text-right text-no-wrap">
										<span v-if="item.data.competitor">{{ euroCent(item.data.competitor.price) }}</span>
										<span v-else class="in-muted">—</span>
									</td>
									<td class="text-right text-no-wrap">{{ item.data.margin === null || item.data.margin === undefined ? '—' : percento(item.data.margin) }}</td>
									<td class="text-right text-no-wrap">
										<div>{{ Math.round(item.data.lostUnits) }} pz</div>
										<div class="in-muted">{{ euro(item.impact) }}</div>
									</td>
									<td class="text-left text-no-wrap">
										<template v-if="item.data.discount">
											<v-chip x-small label color="primary" class="mr-1">Sconto {{ item.data.discount }}%</v-chip>
											<v-chip x-small label outlined color="purple">Coupon {{ item.data.coupon }}%</v-chip>
										</template>
										<v-chip v-else x-small label outlined color="grey darken-1">Migliora la scheda</v-chip>
									</td>
								</tr>
							</tbody>
							<tbody v-else>
								<tr v-for="item in items" :key="item._id">
									<td class="pl-1 pr-0" style="width: 44px"><InsightRowMenu :item="item" @open="apri" @status="cambiaStato" /></td>
									<td style="width: 64px">
										<div class="in-thumb">
											<img v-if="item.data.image" :src="item.data.image" alt="" loading="lazy" />
											<v-icon v-else :color="area(item.area).colore">{{ area(item.area).icona }}</v-icon>
										</div>
									</td>
									<td class="text-left in-main">
										<div class="font-weight-medium in-name">{{ item.title }}</div>
										<div class="in-text">{{ item.text }}</div>
										<div class="in-muted"><v-icon x-small>mdi-information-outline</v-icon> {{ item.why }}</div>
									</td>
									<td class="text-no-wrap">
										<v-chip x-small label outlined :color="area(item.area).colore">{{ area(item.area).label }}</v-chip>
									</td>
									<td class="text-no-wrap">
										<v-chip x-small label :color="gravita(item.severity).colore" text-color="white">{{ gravita(item.severity).label }}</v-chip>
									</td>
									<td class="text-right text-no-wrap font-weight-medium">{{ euro(item.impact) }}</td>
									<td class="text-no-wrap">{{ item.created_at | moment('DD/MM/YYYY') }}</td>
								</tr>
							</tbody>
						</template>
					</v-data-table>
				</SectionCard>

				<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" multi-line :timeout="snackbar.timeout">
					{{ snackbar.text }}
					<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
				</v-snackbar>
			</v-container>
		</v-main>
	</div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import SectionCard from '@/components/core/SectionCard.vue';
import { listRouteState } from '@/components/core/list/listRouteState';
import { openWithReturn, returnInfo, goBackWithResult } from '@/components/core/pageReturn';
import InsightsKpi from '@/components/insights/InsightsKpi.vue';
import InsightRowMenu from '@/components/insights/InsightRowMenu.vue';
import InsightsRadar from '@/components/insights/InsightsRadar.vue';
import { TIPI, STATI, GRAVITA, area, euro, euroCent, percento, destinazione } from '@/components/insights/formato';

const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'InsightsList',
	// pagina, righe, ordinamento, ricerca, scheda, area e stato stanno nell'URL
	mixins: [listRouteState({ filters: { type: 'string', area: 'string', status: 'string' }, perPageOptions: LIST_SIZE })],
	components: { KeyValueCard, SectionCard, InsightsKpi, InsightRowMenu, InsightsRadar },
	data() {
		return {
			ret: returnInfo(this.$route),
			snackbar: { snackbar: false, color: '', timeout: 5000, text: '' },
			settings: this.listSettingsFromRoute({
				search: '',
				filters: { type: '', area: '', status: 'open' },
				options: { sortBy: ['impact'], sortDesc: [true], page: 1, itemsPerPage: 15 },
			}),
			listSize: LIST_SIZE,
			searchfield: '',
			total: 0,
			ricalcolo: false,
			TIPI,
			STATI,
		};
	},
	sockets: {
		// il backend lo invia a fine ricalcolo (coda insights)
		INSIGHTS_READY() {
			if (!this.ricalcolo) return;
			this.ricalcolo = false;
			this.notifica('success', 'Consigli aggiornati');
			this.getDataFromApi(false);
		},
	},
	mounted() {
		this.searchfield = this.settings.search || '';
		this.listLoad();
	},
	computed: {
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		tipo() {
			return ['viewed', 'radar'].includes(this.settings.filters.type) ? this.settings.filters.type : '';
		},
		// il radar segue il filtro area delle tessere in testa
		radarItems() {
			const a = this.settings.filters.area;
			return a ? this.getRadar.filter(i => i.area === a) : this.getRadar;
		},
		tipoCorrente() {
			return TIPI.find(t => t.value === this.tipo);
		},
		statoFiltro() {
			return this.settings.filters.status || 'open';
		},
		// le schede sono il filtro "type" della lista: cambiarle riparte da pagina 1 e resta nell'URL
		tabTipo: {
			get() {
				return Math.max(
					0,
					TIPI.findIndex(t => t.value === this.tipo),
				);
			},
			set(i) {
				this.settings.filters.type = TIPI[i].value;
			},
		},
		headers() {
			if (this.tipo === 'viewed') {
				return [
					{ text: '', value: '', sortable: false },
					{ text: '', value: 'image', sortable: false },
					{ text: 'Prodotto', value: 'title' },
					{ text: 'Visite', value: 'data.views', sortable: false, align: 'end' },
					{ text: 'Ordini', value: 'data.orders', sortable: false, align: 'end' },
					{ text: 'Conversione', value: 'data.conv', sortable: false, align: 'end' },
					{ text: 'Prezzo', value: 'data.price', sortable: false, align: 'end' },
					{ text: 'Concorrente', value: 'data.competitor', sortable: false, align: 'end' },
					{ text: 'Margine', value: 'data.margin', sortable: false, align: 'end' },
					{ text: 'Vendite perse', value: 'impact', align: 'end' },
					{ text: 'Proposta', value: 'action', sortable: false },
				];
			}
			return [
				{ text: '', value: '', sortable: false },
				{ text: '', value: 'image', sortable: false },
				{ text: 'Consiglio', value: 'title' },
				{ text: 'Area', value: 'area', sortable: false },
				{ text: 'Priorità', value: 'severity' },
				{ text: 'Valore stimato', value: 'impact', align: 'end' },
				{ text: 'Rilevato il', value: 'created_at' },
			];
		},
		filtriAttivi() {
			const f = this.settings.filters;
			return !!(f.area || (f.status && f.status !== 'open') || this.settings.search);
		},
		...mapGetters({
			getItems: 'insights/getItems',
			getSummary: 'insights/getSummary',
			getRadar: 'insights/getRadar',
		}),
	},
	methods: {
		...mapMutations({ setPreload: 'settings/setPreload', setLogout: 'profile/setLogout' }),
		back() {
			goBackWithResult(this.$router, this.ret, '', null);
		},
		...mapActions({
			fetchItems: 'insights/asyncFetchData',
			fetchSummary: 'insights/fetchSummary',
			fetchRadar: 'insights/fetchRadar',
			setStatus: 'insights/setStatus',
			refresh: 'insights/refresh',
			destroyData: 'insights/destroyData',
		}),
		area,
		euro,
		euroCent,
		percento,
		gravita(s) {
			return GRAVITA[s] || GRAVITA[1];
		},
		campiCard(item) {
			const d = item.data || {};
			if (item.type === 'viewed') {
				return [
					{ label: 'Visite / ordini', value: `${d.views} / ${d.orders}` },
					{ label: 'Conversione', value: `${percento(d.conv)} (categoria ${percento(d.catConv)})`, strong: true },
					{ label: 'Prezzo', value: euroCent(d.price) },
					{ label: 'Concorrente', value: d.competitor ? euroCent(d.competitor.price) : '' },
					{ label: 'Proposta', value: d.discount ? `Sconto ${d.discount}% o coupon ${d.coupon}%` : 'Migliora la scheda' },
				];
			}
			return [
				{ label: 'Consiglio', value: item.text },
				{ label: 'Perché', value: item.why },
				{ label: 'Valore stimato', value: euro(item.impact), strong: true },
				{ label: 'Area', value: area(item.area).label },
			];
		},
		notifica(color, text) {
			this.snackbar = { snackbar: true, color, timeout: 6000, text };
		},
		errore(err) {
			const res = err.response;
			if (res && res.status === 401) {
				this.setLogout();
				this.$router.push('/login');
				return;
			}
			const errors = res && res.data && res.data.error;
			this.notifica('error', _.isArray(errors) ? errors.map(e => e.msg).join(', ') : (res && res.data && res.data.message) || err.message);
		},
		// il mixin della lista riporta a pagina 1 e ricarica quando cambia la ricerca
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= 3 ? this.searchfield : '';
		},
		pulisciRicerca() {
			this.searchfield = '';
			this.getSearch();
		},
		getDataFromApi(preload = true) {
			if (preload) this.setPreload(true);
			// il radar non e' una lista: niente paginazione, tutti i consigli da fare in una chiamata
			const elenco = this.tipo === 'radar' ? this.fetchRadar().then(r => ({ total: r.length })) : this.fetchItems(this.settings);
			return Promise.all([elenco, this.fetchSummary().catch(err => this.errore(err))])
				.then(([result]) => {
					this.total = result ? result.total : 0;
				})
				.catch(err => console.log(err))
				.finally(() => preload && this.setPreload(false));
		},
		async aggiorna() {
			this.ricalcolo = true;
			try {
				await this.refresh();
				this.notifica('info', 'Ricalcolo avviato: la lista si aggiorna da sola appena finisce.');
			} catch (err) {
				this.ricalcolo = false;
				this.errore(err);
			}
		},
		// la freccia della pagina aperta riporta qui, con scheda, filtri e pagina dell'URL
		apri({ item, tipo }) {
			const dove = destinazione(item, tipo);
			if (!dove) return;
			openWithReturn(this, dove, { label: 'Torna ai consigli' });
		},
		async cambiaStato({ item, status, snoozeDays }) {
			this.setPreload(true);
			try {
				await this.setStatus({ item, status, snoozeDays });
				const testi = { done: 'Consiglio segnato come fatto', snoozed: 'Consiglio rimandato di 7 giorni', dismissed: 'Consiglio ignorato', new: 'Consiglio rimesso fra quelli da fare' };
				this.notifica('success', testi[status]);
				await this.getDataFromApi(false);
			} catch (err) {
				this.errore(err);
			} finally {
				this.setPreload(false);
			}
		},
	},
	beforeDestroy() {
		this.destroyData();
	},
};
</script>

<style scoped>
.in-page {
	max-width: 1600px;
}
.in-top {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px 12px;
	margin-bottom: 16px;
}
.in-title {
	font-size: 20px;
	font-weight: 600;
	color: #1f2d3d;
}
.in-muted {
	font-size: 12px;
	color: #5f6b7a;
}
.in-text {
	font-size: 13px;
	color: #1f2d3d;
	margin: 2px 0;
}
.in-page ::v-deep .section-card {
	height: auto;
}
.in-filters {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 10px 16px;
	margin-bottom: 8px;
}
.in-search {
	max-width: 300px;
}
.in-tabs {
	max-width: 760px;
}
.in-states {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
}
.in-empty {
	text-align: center;
	padding: 32px 0;
	color: #5f6b7a;
}
.in-main {
	padding-top: 8px !important;
	padding-bottom: 8px !important;
	max-width: 640px;
}
.in-thumb {
	width: 48px;
	height: 48px;
	border-radius: 6px;
	background: #f2f4f8;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
}
.in-thumb img {
	width: 100%;
	height: 100%;
	object-fit: contain;
	background: #fff;
}
.in-name {
	max-width: 420px;
	white-space: normal;
	word-break: break-word;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.in-cards,
.in-cards tr {
	display: block;
	width: 100%;
}
.in-cards tr,
.in-cards tr:hover {
	background: transparent !important;
}
.in-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
</style>
